//# sourceMappingURL=endpoints.mjs.map
/// <reference types="./endpoints.d.mts" />
import * as $string from "../../gleam_stdlib/gleam/string.mjs";
import * as $vitools from "../../vitools/vitools.mjs";
import * as $mode from "../../vitools/vitools/mode.mjs";
import { Ok } from "../gleam.mjs";

/**
 * - `http://127.0.0.1:5173` in Cypress.
 * - `http://localhost:5173` in development.
 * - `https://steerlab.dev` in staging.
 * - `https://app.steerlab.ai` in production.
 */
export function frontend() {
  let $ = $vitools.get_env("APP_ENDPOINT");
  if ($ instanceof Ok) {
    let value = $[0];
    return value;
  } else {
    let $1 = $mode.mode();
    if ($1 instanceof $mode.Production) {
      return "https://app.steerlab.ai";
    } else if ($1 instanceof $mode.Staging) {
      return "https://steerlab.dev";
    } else if ($1 instanceof $mode.Development) {
      return "http://localhost:5173";
    } else {
      return "http://127.0.0.1:5173";
    }
  }
}

/**
 * Reads `API_ENDPOINT` environment variable, or use default values
 * according to the mode the application is running in.
 * 
 * @ignore
 */
function api() {
  let $ = $vitools.get_env("API_ENDPOINT");
  if ($ instanceof Ok) {
    let value = $[0];
    return value;
  } else {
    let $1 = $mode.mode();
    if ($1 instanceof $mode.Production) {
      return "https://api.steerlab.ai";
    } else if ($1 instanceof $mode.Staging) {
      return "https://api.steerlab.dev";
    } else if ($1 instanceof $mode.Development) {
      return "http://localhost:3000";
    } else {
      return "http://127.0.0.1:3000";
    }
  }
}

/**
 * - `http://127.0.0.1:3000/heimdall` in Cypress.
 * - `http://localhost:3000/heimdall` in development.
 * - `https://api.steerlab.dev/heimdall` in staging.
 * - `https://api.steerlab.ai/heimdall` in production.
 */
export function heimdall() {
  return api() + "/heimdall";
}

/**
 * - `http://127.0.0.1:3000/loki` in Cypress.
 * - `http://localhost:3000/loki` in development.
 * - `https://api.steerlab.dev/loki` in staging.
 * - `https://api.steerlab.ai/loki` in production.
 */
export function loki() {
  return api() + "/loki";
}

/**
 * - `http://127.0.0.1:3000/nabu` in Cypress.
 * - `http://localhost:3000/nabu` in development.
 * - `https://api.steerlab.dev/nabu` in staging.
 * - `https://api.steerlab.ai/nabu` in production.
 */
export function nabu() {
  return api() + "/nabu";
}

/**
 * - `http://127.0.0.1:3000/hermes/slack/redirect` in Cypress.
 * - `http://localhost:3000/hermes/slack/redirect` in development.
 * - `https://api.steerlab.dev/hermes` in staging.
 * - `https://api.steerlab.ai/hermes` in production.
 */
export function hermes() {
  let $ = $mode.dev();
  if ($) {
    return api() + "/hermes/slack/redirect";
  } else {
    return api() + "/hermes";
  }
}

/**
 * - `ws://127.0.0.1:3000/wss` in Cypress.
 * - `ws://localhost:3000/wss` in development.
 * - `wss://api.steerlab.dev/wss` in staging.
 * - `wss://api.steerlab.ai/wss` in production.
 */
export function wss() {
  let _pipe = api();
  let _pipe$1 = $string.replace(_pipe, "http", "ws");
  let _pipe$2 = $string.replace(_pipe$1, "https", "wss");
  return $string.append(_pipe$2, "/wss");
}
